import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { BillingDoOrdenControlDialogComponent } from '../../dialogs/billing-do-orden-control-dialog/billing-do-orden-control-dialog.component';
import { Router } from '@angular/router';
import { MenuService } from '../../../services/menu.service';
 

@Component({
  selector: 'app-billing-orden-control-do',
  templateUrl: './billing-orden-control-do.component.html',
  styleUrls: ['./billing-orden-control-do.component.css']
})
export class BillingOrdenControlDoComponent implements OnInit {

  constructor( private dialog: MatDialog,
               private menuService: MenuService,
               private router: Router) {
                menuService.setMenuTitle('Control órden');
  }

  ngOnInit() {
    const dialogRef = this.dialog.open(BillingDoOrdenControlDialogComponent, {
      width: '500px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.router.navigate(['billing-orden-control-wizard',
          result.MedicalAppointmentId, result.Protocol, result.MedicalOrderId]);
      }
    });
  }
}
